var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-media-bar"},_vm._l((_vm.socialMedia),function(entity,index){return _c('div',{key:index,staticClass:"image-container",on:{"click":function($event){return _vm.navigateToSocialMedia(entity.mediaUrl)}}},[_c('v-img',{staticClass:"social-media-image",attrs:{"src":entity.imageUrl}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }